import { render, staticRenderFns } from "./CardParts.vue?vue&type=template&id=7caf18e8&scoped=true&"
import script from "./CardParts.vue?vue&type=script&lang=js&"
export * from "./CardParts.vue?vue&type=script&lang=js&"
import style0 from "./CardParts.vue?vue&type=style&index=0&id=7caf18e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf18e8",
  null
  
)

export default component.exports